// extracted by mini-css-extract-plugin
export default {"main":"main_main__NHP4G","header":"main_header__+JcLA","logo":"main_logo__i7Te+","name":"main_name__c7DFK","title":"main_title__-D0gH","content":"main_content__mUzky"};